/**
 * Kauffman Sidebar Component
 *
 * Apply additional functionality to article sidebar
 */
import { Component } from 'js-component-framework';
import Sticky from 'stickybits';

/**
 * Sidebar Class
 */
export default class Sidebar extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.initStickySidebar = this.initStickySidebar.bind(this);
    this.init();
  }

  /**
   * Initialize sticky sidebar
   */
  initStickySidebar() {
    this.stickySidebar = new Sticky(this.element, {
      useGetBoundingClientRect: true,
    });
  }

  /**
   * Function that fires when component loads.
   */
  init() {
    this.initStickySidebar();
  }
}
